import * as FormControl from '../utils/form-controls';
import * as CONST from '../utils/constants';

// global window
const filterObj = CONST.globalProject.PersonFilters;

// initial state
// object name must match specification name
const filters = {
	PersonType: new FormControl.FilterGroup('PersonType', 'Filter by Type', 'Select a Type', '', false, true, 'checkbox'),
};

FormControl.assignFilters(filterObj, filters);

export { filters as default };